// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3VBBa","label":"Section_label__3BPOG","contentWrap":"Section_contentWrap__2ktH0","footer":"Section_footer__3YYJo","footerInner":"Section_footerInner__18KsG"};